/* Mold Labs — ml-ui.js v1
   Delivered as a NEW asset file so no cache or speed-optimizer app can serve
   a stale copy. Self-contained, retries after load in case the page gets
   rewritten late. Everything is painted directly on the elements (inline via
   JS), so stripped/stale section CSS cannot affect it.

   1) Header nav: underline the menu item matching the current page URL.
   2) Care page ("Údržba a péče"): temperature status dot — blue in the freeze /
      chill zones (under 40 °C), green in temperace/sušení (40–99 °C), orange in
      "Pečení" (100–199 °C) and red in "Vysoký žár" (200 °C+). */
(function () {
  try { console.log('[Mold Labs] ml-ui.js v1 active'); } catch (e) {}

  var GREEN = '#5ccc78', INK = '#0f0f0e', ORANGE = '#E8833A', RED = '#E0473F', BLUE = '#3F86E0';

  /* ---------- 1) active nav underline ---------- */
  function navUnderline() {
    var nav = document.querySelector('[data-ml-nav]');
    if (!nav) return;
    var links = [].slice.call(nav.querySelectorAll('.ml-header__navlink'));
    if (!links.length) return;
    var norm = function (p) { p = (p || '').replace(/[?#].*$/, '').replace(/\/+$/, ''); return p === '' ? '/' : p; };
    var here = norm(window.location.pathname);
    var best = null, bestLen = -1;
    links.forEach(function (a) {
      var href = a.getAttribute('href') || '';
      if (!href || href === '#') return;
      var lp;
      try { lp = norm(new URL(href, window.location.origin).pathname); } catch (e) { return; }
      if (lp === '/') { if (here === '/' && bestLen < 0) { best = a; bestLen = 0; } return; }
      if ((here === lp || here.indexOf(lp + '/') === 0) && lp.length > bestLen) { best = a; bestLen = lp.length; }
    });
    links.forEach(function (a) {
      a.classList.remove('is-active');
      a.removeAttribute('aria-current');
      a.style.borderBottom = '2px solid transparent';
      a.style.color = '';
    });
    if (best) {
      best.classList.add('is-active');
      best.setAttribute('aria-current', 'page');
      best.style.borderBottom = '2px solid ' + GREEN;
      best.style.color = INK;
    }
  }

  /* ---------- 2) care page temperature dot ---------- */
  function careDot() {
    var temp = document.querySelector('[data-care-temp]');
    if (!temp || temp.__mlDot) return;
    var range = temp.querySelector('[data-care-temp-range]');
    var dot = temp.querySelector('.ml-care__temp-dot');
    if (!range || !dot) return;
    temp.__mlDot = true;
    var paint = function () {
      var t = parseInt(range.value, 10) || 0;
      if (t >= 200) {          /* Vysoký žár */
        dot.style.background = RED;
        dot.style.animation = 'none';
        dot.style.boxShadow = '0 0 0 4px rgba(224,71,63,.22)';
      } else if (t >= 100) {   /* Pečení */
        dot.style.background = ORANGE;
        dot.style.animation = 'none';
        dot.style.boxShadow = '0 0 0 4px rgba(232,131,58,.22)';
      } else if (t < 40) {    /* mražení + chlazení — modrá */
        dot.style.background = BLUE;
        dot.style.animation = 'none';
        dot.style.boxShadow = '0 0 0 4px rgba(63,134,224,.22)';
      } else {                 /* safe range — brand green */
        dot.style.background = GREEN;
        dot.style.animation = '';
        dot.style.boxShadow = '';
      }
    };
    range.addEventListener('input', paint);
    range.addEventListener('change', paint);
    paint();
  }

  function runAll() {
    try { navUnderline(); } catch (e) {}
    try { careDot(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runAll);
  } else {
    runAll();
  }
  /* re-run in case a speed/optimizer app rewrites the page after load */
  setTimeout(runAll, 400);
  setTimeout(runAll, 1200);
  setTimeout(runAll, 3000);
  window.addEventListener('pageshow', runAll);
})();
